

















































































import Vue from "vue";
import cloneDeep from "lodash/cloneDeep";
import without from "lodash/without";

import { mapState } from "vuex";

export default Vue.extend({
  name: "TestCaseForm",
  props: {
    saveLabel: String,
    title: {
      type: String,
      required: false
    },
    testCase: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      model: cloneDeep(this.testCase)
    };
  },
  computed: mapState(["testSuits"]),
  methods: {
    save() {
      this.$emit("save", this.model);
    },
    addStep() {
      let number = 0;
      this.model.steps.forEach(function(step: any) {
        if (step.number > number) {
          number = step.number;
        }
      });
      this.model.steps.push({
        number: number + 1
      });
    },
    removeStep(step: any) {
      this.model.steps = without(this.model.steps, step);
    }
  }
});
